import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { useTranslation } from "react-i18next"
import { CustomerResponseDataSchema, DataResponse } from "schema"
import { toast } from "sonner"
import { z } from "zod"
import { getCustomerQueryKey } from "../lib/customerQuery"
import { getCustomersQueryKey } from "../lib/customersQuery"

type Response = DataResponse<z.infer<typeof CustomerResponseDataSchema>>

type Props = {
  customerId: string
}

export function useRemoveOptOutCustomerMutation(props: Props) {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const response = await axios.patch<Response>(`/customers/${props.customerId}/remove-opt-out`)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getCustomerQueryKey(props.customerId),
      })
      queryClient.invalidateQueries({ queryKey: getCustomersQueryKey() })
      toast.success(t("customers.profile.optIn.success"))
    },
  })
}
